// Libraries
import { Component } from "react";

// Components


// Assets
import "./../assets/styles/Home.css";

class Home extends Component {
    render() {
        return(
            <div id="home">
                <div className="container fadeIn">
                    <div className="section-1 parallax">
                        <div className="intro">
                            <h1>Vincent Yen</h1>
                            <h2>Software Developer</h2>
                        </div>
                            <p>Photo Credit: Peter Peck</p>
                    </div>
                </div>
            </div>
        );
    };
};

export default Home;